import { DeviceTemplateLambdaTrigger } from "./DeviceTemplateLambdaTrigger";

export class DeviceTemplate {
    id: string = "";
    name: string = "";
    triggers: DeviceTemplateLambdaTrigger[] = [];


    constructor(init?:Partial<DeviceTemplate>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.triggers) {
            this.triggers = init.triggers.map(t => new DeviceTemplateLambdaTrigger(t));
        }
    }

    toDetailPageUrl() {
        return `/device-templates/${this.id}`
    }
}
